'use strict';

import { Encrypt, Decrypt } from './secret.js';
import { base_encode } from './base64.js';
import { GetShort } from './localstore.js';

// 样例方法
// export function Method_Login(data) {
//   var mm = Encrypt(data, "0123456789abcdef", "0123456789abcdef");
//   console.log("统一 密文=" + mm);
//   return '{"method":"login","data":"' + mm + '"}';
// }

// 登录方法
export function Method_Login(userno, userpwd) {
	var data = base_encode('{"userno":"' + userno + '","userpwd":"' + userpwd + '"}');
	return '{"method":"login","data":"' + data + '"}';
}
// 注册方法
export function Method_Regin(phone, email, userpwd, code, username) {
	var data = base_encode(
		'{"phone":"' +
			phone +
			'","userpwd":"' +
			userpwd +
			'","email":"' +
			email +
			'","code":"' +
			code +
			'","username":"' +
			username +
			'"}'
	);
	return '{"method":"regin","data":"' + data + '"}';
}

export function Method_Encrypt(parm1, parm2, parm3) {
	var card_no = '',
		key = '',
		iv = '';
	key = checkstr(parm2);
	iv = checkstr(parm3);
	card_no = Encrypt(parm1, key, iv);
	return card_no;
}

export function Method_Decrypt(parm1, parm2, parm3) {
	var card_no = '',
		key = '',
		iv = '';

	key = checkstr(parm2);
	iv = checkstr(parm3);
	card_no = Decrypt(parm1, key, iv);
	return card_no;
}

function checkstr(key) {
	var exp = 'abcdefghijklmnobqistuvdwsadkjfal';
	if (key.length < 16) {
		key = key + exp.substr(0, 16 - key.length);
	}
	if (key.length > 16) {
		key = key.substr(0, 16);
	}
	return key;
}

// 用户信息操作
export function Method_UserAction(action, id, userno, username, role_id, phone, email, weixin, qq, address, sys_date) {

	var data = base_encode(
		'{"action":"' +
			action +
			'","user_no":"' +
			GetShort('userno') +
			'","row_id":"' +
			id +
			'","userno":"' +
			userno +
			'","username":"' +
			username +
			'","role_id":"' +
			role_id +
			'","phone":"' +
			phone +
			'","email":"' +
			email +
			'","weixin":"' +
			weixin +
			'","qq":"' +
			qq +
			'","address":"' +
			address +
			'","sys_date":"' +
			sys_date +
			'"}'
	);
	return '{"method":"user","data":"' + data + '"}';
}

// 帮助信息与类别操作
// export function Method_HelpAction(
//   action,
//   id,
//   h_short,
//   h_title,
//   h_title_en,
//   h_data,
//   h_data_en,
//   sys_date,
//   h_id
// ) {
//   var data = base_encode(
//     '{"action":"' +
//       action +
//       '","userno":"' +
//       GetShort("userno") +
//       '","row_id":"' +
//       id +
//       '","h_short":"' +
//       h_short +
//       '","h_title":"' +
//       h_title +
//       '","h_title_en":"' +
//       h_title_en +
//       '","h_data":"' +
//       h_data +
//       '","h_data_en":"' +
//       h_data_en +
//       '","sys_date":"' +
//       sys_date +
//       '","h_id":"' +
//       h_id +
//       '"}'
//   );
//   return '{"method":"helptypeordata","data":"' + data + '"}';
// }

// 统一简单查询
export function Method_EasySelect(action, data1, data2, data3, data4, data5) {
  // console.log('userno='+GetShort('userno'));

  var data = base_encode(
    '{"action":"' +
    action +
    '","user_no":"' +
    GetShort("userno") +
    '","data1":"' +
    data1 +
    '","data2":"' +
    data2 +
    '","data3":"' +
    data3 +
    '","data4":"' +
    data4 +
    '","data5":"' +
    data5 +
    '"}'
  );
  return '{"method":"easyselect","data":"' + data + '"}';
}

// 统一简单增加
export function Method_EasyAdd(action, data1, data2, data3, data4, data5) {
  var data = base_encode(
    '{"action":"' +
    action +
    '","user_no":"' +
    GetShort("userno") +
    '","add_data1":"' +
    data1 +
    '","add_data2":"' +
    data2 +
    '","add_data3":"' +
    data3 +
    '","add_data4":"' +
    data4 +
    '","add_data5":"' +
    data5 +
    '"}'
  );
  return '{"method":"easyadd","data":"' + data + '"}';
}

// 统一简单删除
export function Method_EasyDelete(action, rowid) {
  var data = base_encode(
    '{"action":"' + action + '","user_no":"' + GetShort("userno") + '","rowid":"' + rowid + '"}'
  );
  return '{"method":"easydelete","data":"' + data + '"}';
}

// 统一简单修改
export function Method_EasyUpdate(action, id, data1, data2, data3, data4, sys_date) {
  var data = base_encode(
    '{"action":"' +
    action +
    '","user_no":"' +
    GetShort("userno") +
    '","rowid":"' +
    id +
    '","add_data1":"' +
    data1 +
    '","add_data2":"' +
    data2 +
    '","add_data3":"' +
    data3 +
    '","add_data4":"' +
    data4 +
    '","sys_date":"' +
    sys_date +
    '"}'
  );
  return '{"method":"easyupdate","data":"' + data + '"}';
}


// 整合 table 查询
export function tab_file_select(keyword, nowpage) {
	var postdata = '';
	postdata =
		'{"action":"data_downfile_art","user_no":"' +
		GetShort('userno') +
		'","upfile_name":"' +
		keyword +
		'","page_num":"' +
		nowpage +
		'","rowid":"0"}';
	postdata = '{"method":"File_down","data":"' + base_encode(postdata) + '"}';
	return postdata;
}

// 分页查询
export function Method_DataByPage(action, page, data1, data2, data3, data4, data5,data6,data7,data8,data9,data10, r) {
  var data = base_encode(
    '{"action":"' +
    action +
    '","user_no":"' +
    GetShort("userno") +
    '","page_num":"' +
    page +
    '","data1":"' +
    data1 +
    '","data2":"' +
    data2 +
    '","data3":"' +
    data3 +
    '","data4":"' +
    data4 +
    '","data5":"' +
    data5 +
    '","data6":"' +
    data6 +
    '","data7":"' +
    data7 +
    '","data8":"' +
    data8 +
    '","data9":"' +
    data9 +
    '","data10":"' +
    data10 +
    '","r":"' +
    r +
    '"}'
  );
  // console.log(base_decode(data));
  return '{"method":"selectbypage","data":"' + data + '"}';
}

// 分页查询
export function Select_PageLength(action, page, perpage, data1, data2, data3, data4, data5,data6,data7,data8,data9,data10, r) {
  var data = base_encode(
    '{"action":"' +
    action +
    '","user_no":"' +
    GetShort("userno") +
    '","page_num":"' +
    page +
    '","per_page":"' +
    perpage +
    '","data1":"' +
    data1 +
    '","data2":"' +
    data2 +
    '","data3":"' +
    data3 +
    '","data4":"' +
    data4 +
    '","data5":"' +
    data5 +
    '","data6":"' +
    data6 +
    '","data7":"' +
    data7 +
    '","data8":"' +
    data8 +
    '","data9":"' +
    data9 +
    '","data10":"' +
    data10 +
    '","r":"' +
    r +
    '"}'
  );
  return '{"method":"selectpageandlength","data":"' + data + '"}';
}

// 复杂查询，入参ID 返回一个长数据
export function Method_ComplexSelect(action,id){
  var data = base_encode(
		'{"action":"' +
			action +
			'","user_no":"' +
			GetShort('userno') +
			'","row_id":"' +
			id +
			'"}'
	);
	return '{"method":"complex_select","data":"' + data + '"}';
}

// 复杂编辑，入参ID 返回一个长数据
export function Method_ComplexUpdate(action,id,innerHtml,innerText){
  var data = base_encode(
		'{"action":"' +
			action +
			'","user_no":"' +
			GetShort('userno') +
			'","row_id":"' +
			id +
			'","complexdata1":"' +
			innerHtml +
			'","complexdata2":"' +
			innerText +
			'"}'
	);
	return '{"method":"complex_update","data":"' + data + '"}';
}

//微信请求
export function weixin_pay(phone, email, code, paytype) {
	var postdata = '';
	// paytype 支付类型预留

	postdata =
		'{"user_no":"' +
		GetShort('userno') +
		'","phone":"' +
		phone +
		'","email":"' +
		email +
		'","code":"' +
		code +
		'","paytype":"' +
		paytype +
		'"}';
	postdata = '{"method":"weixin_pay_sheet","data":"' + base_encode(postdata) + '"}';
	return postdata;
}

//微信请求
export function weixin_payresult(sheet_no) {
	var postdata = '';
	postdata = '{"user_no":"' + GetShort('userno') + '","sheetno":"' + sheet_no + '"}';
	postdata = '{"method":"weixin_pay_back","data":"' + base_encode(postdata) + '"}';
	return postdata;
}

// 统一5字段操作
export function File_Info(action, row_id, data1, data2, data3, data4, data5) {
  var data = base_encode(
    '{"action":"' +
    action +
    '","user_no":"' +
    GetShort("userno") +
    '","row_id":"' +
    row_id +
    // '","sys_date":"' +
    // sys_date +
    '","data1":"' +
    data1 +
    '","data2":"' +
    data2 +
    '","data3":"' +
    data3 +
    '","data4":"' +
    data4 +
    '","data5":"' +
    data5 + '"}'
  );
  return '{"method":"File_Info","data":"' + data + '"}';
}

// 统一15字段操作
export function Method_Common(action, row_id, sys_date, parm) {

  let temp = '';
  for (let i = 0; i < parm.length; i++) {
    temp = temp + '","data' + (i + 1) + '":"' + parm[i];
  }


  var data = base_encode(
    '{"action":"' +
    action +
    '","user_no":"' +
    GetShort("userno") +
    '","row_id":"' +
    row_id +
    '","sys_date":"' +
    sys_date +
    temp + '"}'
  );
  return '{"method":"common","data":"' + data + '"}';
}

// 统一30字段操作
export function Method_CommonLong(action, row_id, sys_date, parm) {

  let temp = '';
  for (let i = 0; i < parm.length; i++) {
    temp = temp + '","data' + (i + 1) + '":"' + parm[i];
  }


  var data = base_encode(
    '{"action":"' +
    action +
    '","user_no":"' +
    GetShort("userno") +
    '","row_id":"' +
    row_id +
    '","sys_date":"' +
    sys_date +
    temp + '"}'
  );
  return '{"method":"commonlong","data":"' + data + '"}';
}

// 统一50字段操作
export function Method_CommonLongLong(action, row_id, sys_date, parm) {

  let temp = '';
  for (let i = 0; i < parm.length; i++) {
    temp = temp + '","data' + (i + 1) + '":"' + parm[i];
  }


  var data = base_encode(
    '{"action":"' +
    action +
    '","user_no":"' +
    GetShort("userno") +
    '","row_id":"' +
    row_id +
    '","sys_date":"' +
    sys_date +
    temp + '"}'
  );
  return '{"method":"commonlonglong","data":"' + data + '"}';
}

export function Method_Address(p) {
	var data = base_encode(p);
	return '{"method":"Address","data":"' + data + '"}';
}

// add 2022-01-25
// 特殊传递 第三个字段为 val=name^val=name^val=name^val=name 结构。需要后台解析
export function Method_TableAll(action,check_key,row_id, sys_date, parm) {

  var data = base_encode(
    '{"action":"' +
    action +
    '","user_no":"' +
    GetShort("userno") +
	'","check_key":"' +
	check_key + 
	'","row_id":"' +
	row_id +
	'","sys_date":"' +
	sys_date +
	'","parm":"' +
    parm + '"}'
  );
  return '{"method":"commonstr","data":"' + data + '"}';
}

// add 2022-01-25
// 按照页码和单页长度
export function Sel_page_and_length(action, page, perpage, data1, data2, data3, data4, data5,data6,data7,data8,data9,data10, r) {
  var data = base_encode(
    '{"action":"' +
    action +
    '","user_no":"' +
    GetShort("userno") +
    '","page_num":"' +
    page +
    '","per_page":"' +
    perpage +
    '","data1":"' +
    data1 +
    '","data2":"' +
    data2 +
    '","data3":"' +
    data3 +
    '","data4":"' +
    data4 +
    '","data5":"' +
    data5 +
    '","data6":"' +
    data6 +
    '","data7":"' +
    data7 +
    '","data8":"' +
    data8 +
    '","data9":"' +
    data9 +
    '","data10":"' +
    data10 +
    '","r":"' +
    r +
    '"}'
  );
  return '{"method":"select_page_length","data":"' + data + '"}';
}


export function Method_CompanyAction(
  action,
  id,
  cno,
  cname,
  cuser,
  cphone1,
  cphone2,
  cemail,
  caddress,
  cqq,
  bid,
  cid,
  sys_date
) {
  var data = base_encode(
    '{"action":"' +
    action +
    '","row_id":"' +
    id +
    '","userno":"' +
    GetShort("userno") +
    '","cno":"' +
    cno +
    '","cname":"' +
    cname +
    '","cuser":"' +
    cuser +
    '","cphone1":"' +
    cphone1 +
    '","cphone2":"' +
    cphone2 +
    '","cemail":"' +
    cemail +
    '","caddress":"' +
    caddress +
    '","cqq":"' +
    cqq +
    '","bid":"' +
    bid +
    '","cid":"' +
    cid +
    '","sys_date":"' +
    sys_date +
    '"}'
  );
  return '{"method":"company","data":"' + data + '"}';
}



// add 2022-01-25
// 按照页码和单页长度 直接 默认查询移动端数据。
export function Sel_Mobile(action, page, perpage, data1, data2, data3, data4, data5,data6,data7,data8,data9,data10, r) {
  var data = base_encode(
    '{"action":"' +
    action +
    '","user_no":"' +
    GetShort("userno") +
    '","page_num":"' +
    page +
    '","per_page":"' +
    perpage +
    '","data1":"' +
    data1 +
    '","data2":"' +
    data2 +
    '","data3":"' +
    data3 +
    '","data4":"' +
    data4 +
    '","data5":"' +
    data5 +
    '","data6":"' +
    data6 +
    '","data7":"' +
    data7 +
    '","data8":"' +
    data8 +
    '","data9":"' +
    data9 +
    '","data10":"' +
    data10 +
    '","r":"' +
    r +
    '"}'
  );
  return '{"method":"Select_Mobile","data":"' + data + '"}';
}

